import { render, staticRenderFns } from "./selectByProduct.vue?vue&type=template&id=f4b1f062&scoped=true"
import script from "./selectByProduct.vue?vue&type=script&lang=js"
export * from "./selectByProduct.vue?vue&type=script&lang=js"
import style0 from "./selectByProduct.vue?vue&type=style&index=0&id=f4b1f062&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b1f062",
  null
  
)

export default component.exports